import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function AwardFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5 1.25C4.58579 1.25 4.25 1.58579 4.25 2V4H2C1.44772 4 1 4.44772 1 5C1 8.20622 2.07515 10.5853 3.9453 11.8321C4.40483 12.1384 5.0257 12.0142 5.33205 11.5547C5.6384 11.0952 5.51423 10.4743 5.0547 10.1679C4.06709 9.50955 3.23611 8.18816 3.04254 6H4.31392C4.76229 9.48047 7.51953 12.2377 11 12.6861V17.3554C8.85686 17.8147 7.25 19.7198 7.25 22C7.25 22.4142 7.58579 22.75 8 22.75H15.9996C16.4137 22.75 16.7495 22.4143 16.7496 22.0001C16.7498 19.7198 15.1431 17.8148 13 17.3555V12.6861C16.4805 12.2377 19.2377 9.48047 19.6861 6H20.9575C20.7639 8.18816 19.9329 9.50955 18.9453 10.1679C18.4858 10.4743 18.3616 11.0952 18.6679 11.5547C18.9743 12.0142 19.5952 12.1384 20.0547 11.8321C21.9249 10.5853 23 8.20622 23 5C23 4.44772 22.5523 4 22 4H19.75V2C19.75 1.58579 19.4142 1.25 19 1.25H5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

AwardFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default AwardFilledIcon;
